import MobileTopicsList from './MobileTopicsList';

export default MobileTopicsList;
